export enum CalendarView {
  BookingsOnly = "bookingsOnly",
  Utilization = "utilization",
  Availability = "availability",
  Compressed = "compressed",
  EngagementsAndAuditEngagements = "engagementsAndAuditEngagements",
  RolesAndAuditRoles = "rolesAndAuditRoles"
}
